<!--
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-02-22 13:50:10
 * @LastEditTime: 2019-03-25 09:15:17
 -->
<template>
  <div class="footer">
    <div class="main">
      <el-row type="flex" class="row-bg topp" justify="center">
        <el-col :span="20" class="maincente">
          <el-col class="cente" v-for="(item, index) in menuDown" :key="index">
            <template v-if="!item.children">
              <ul class="hovers" @click="handleSelect(item)">
                {{
                  item.name
                }}
              </ul>
            </template>
            <template v-if="item.children">
              <span class="titles">{{ item.name }}</span>
              <template
                v-if="Array.isArray(item.children[0].children)"
                v-for="childrenItem in item.children"
              >
                <ul @click="handleSelect(childrenItem)">
                  <li>{{ childrenItem.name }}</li>
                </ul>
                <ul
                  @click="handleSelect(childrenItems)"
                  v-for="childrenItems in childrenItem.children"
                  :key="childrenItems.id"
                >
                  <li>{{ childrenItems.name }}</li>
                </ul>
              </template>
              <template v-if="!item.children[0].children">
                <ul
                  @click="handleSelect(items)"
                  :key="items.id"
                  v-for="items in item.children"
                >
                  <li>{{ items.name }}</li>
                </ul>
              </template>
            </template>
          </el-col>
          <el-col class="aboutus cente">
            <ul style="width: 200px">
              <p>联系我们</p>
              <span
                ><i class="iconfont icon-weixin"></i>
                <img src="@/assets/images/ymddgwdyh.jpg" />
                <a class="ceart"></a>
              </span>
              <span class="aleft"
                ><a
                  target="_blank"
                  href="https://weibo.com/u/5631472758?refer_flag=1005055014_&is_hot=1"
                  ><i class="iconfont icon-weiboheibai"></i></a
              ></span>
              <span class="aleft"
                ><a @click="goonline('在线客服', '1')"
                  ><i class="iconfont icon-kefu"></i></a
              ></span>
              <img class="tele" src="@/assets/images/tele.png" />
            </ul>
          </el-col>
        </el-col>
      </el-row>
      <div style="text-align: center">
        <p>
          <!-- <span style='margin:0 50px;'><img style='cursor:pointer' @click="togo('优速快递')" src="@/assets/images/优速logo白.png" width=166  alt=""></span> -->
          <!-- <span style='margin:0 50px;'><img style='cursor:pointer' @click="togo('汇森速运')" src="@/assets/images/汇森速运白.png" width=144  alt=""></span>
                    <span style='margin:0 50px;'><img style='cursor:pointer' @click="togo('汇霖丰通')" src="@/assets/images/汇霖丰通白.png" width=144  alt=""></span> -->
        </p>
      </div>
    </div>
    <div class="page">
      <p>
          <span @click="toAgreement">《物流服务条款》</span>
        <span @click="toServiceAgreement">《壹米滴答服务条款》</span>
          <span @click="handle">《壹米滴答隐私政策》</span>
          <span @click="toCollectIndividual">《已收集个人信息清单》</span>
          <span @click="toCollectPermission">《权限调用清单》</span>
          <span @click="toThirdPart">《第三方服务协议》</span>
          <span @click="toCorporation">《合作方清单》</span>
          <span @click="toLink('查货物')">查货物</span>
        <span @click="toLink('查网点')">查网点</span>
<!--        <span @click="toLink('查时效')">查时效</span>-->
        <span @click="toLink('开放平台', '1')">开放平台</span>
        <!-- <span @click="toLink('金融服务','1')">金融服务</span> -->

      </p>
    </div>
    <div class="copy">
      <p>
        Copyright © 2015-{{ currentYear }} 上海壹米滴答快运有限公司. All rights reserved.
        <a href="https://beian.miit.gov.cn/">{{ remarkNum }}</a>
        <img src="../../assets/images/beian.png" />
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?COLLCC=3484918587&recordcode=31011802001324"
          >沪公网安备 31011802001324号</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { menuqueryaddressid } from "@/api/menu";
import { findbytype } from "@/api/apiall";
import Bus from "@/utils/bus";
import { mapGetters } from "vuex";
import { getUserInfo } from "@/api/homePage";
export default {
  data() {
    return {
      routerUrl: "",
      modelwidth: "20%",
      logininfo: "",
      companyName: "",
      remarkNum: "",
    };
  },
  computed: {
    ...mapGetters(["menuDown"]),
      currentYear(){
        return new Date().getFullYear();
      }
  },
  created() {
    this.aueryfindbytype();
    sessionStorage.setItem("activeIndex", this.$route.query.id);
    this.getUse();
    this.findbytype();
  },
  watch: {
    $route() {
      this.getUse();
    },
  },
  methods: {
    findbytype() {
      let findbytypeDto = { type: "ymFilingsNumber" };
      findbytype(findbytypeDto).then((res) => {
        if (res.status === 2000) {
          if (
            res &&
            res.data &&
            res.data.length > 0 &&
            res.data[0] &&
            res.data[0].value
          ) {
            if (
              res.data[0].value.split(",") &&
              res.data[0].value.split(",").length > 0
            ) {
              if (res.data[0].value.split(",")[0]) {
                this.companyName = res.data[0].value.split(",")[0];
              }
              if (res.data[0].value.split(",")[1]) {
                this.remarkNum = res.data[0].value.split(",")[1];
              }
            }
          }
        }
      });
    },
    getUse() {
      let MenuQueryDto = { name: "用户接口", sign: "1" };
      menuqueryaddressid(MenuQueryDto).then((res) => {
        if (res.status === 2000) {
          getUserInfo(res.data.routAddress).then((res) => {
            if (res.status == 2000) {
              let result = res.data.data;
              this.logininfo = result;
            } else {
            }
          });
        }
      });
    },
    goonline(item, num) {
        let islogin = sessionStorage.getItem("userInfoView");
        if (islogin == null) {
            sessionStorage.setItem("activeIndex", item.id);
            window.open(
                "/usercenter/login?successUrl=https%3A%2F%2Fwww.yimidida.com",
                "_self"
            );
            return;
        }
      var win = window.open("", "_blank");
      menuqueryaddressid({ sign: num, name: item })
        .then((res) => {
          if (res.status === 2000) {
            if (this.logininfo != "") {
              win.location =
                res.data.routAddress +
                "?openId=" +
                this.logininfo.userCode +
                "&nickname=" +
                this.logininfo.nickname +
                "&gender=" +
                this.logininfo.sex;
            } else {
              win.location = res.data.routAddress;
            }
          }
        })
        .catch((err) => {});
    },
    aueryfindbytype() {
      menuqueryaddressid({ name: "登录", sign: "1" }).then((res) => {
        if (res.status == 2000) {
          this.routerUrl = res.data.routAddress;
        }
      });
    },
    handle() {
      this.$router.push({
        path: "/rivacypolicy",
        query: {
          id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224",
        },
      });
    },
      toAgreement(){
          this.$router.push({
              path: "/logisticsAgreement",
              query: {
                  id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
              }
          });
      },
    toServiceAgreement(){
      this.$router.push({
        path: "/serviceAgreement",
        query: {
          id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
        }
      });
    },
    toCollectIndividual(){
      this.$router.push({
        path: "/collectindividual",
        query: {
          id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
        }
      });
    },
    toCollectPermission(){
      this.$router.push({
        path: "/collectPermission",
        query: {
          id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
        }
      });
    },
    toThirdPart(){
      this.$router.push({
        path: "/thirdpart",
        query: {
          id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
        }
      });
    },
    toCorporation(){
      this.$router.push({
        path: "/corporation",
        query: {
          id: "50EAA720-D4C9-476F-0ACC-8FDC0CBB7224"
        }
      });
    },
    handleSelect(item) {
      var need = "";
      if (
        item.name !== "查物流" &&
        item.name !== "查时效" &&
        item.name !== "查网点" &&
        item.name !== "在线下单"
      ) {
        need = "1";
      }
      if (item.demoFlag == "/demoModel" && need === "1") {
        let islogin = sessionStorage.getItem("userInfoView");
        if (islogin == null) {
          sessionStorage.setItem("activeIndex", item.id);
          window.open(this.routerUrl + "/demoModel?id=" + item.id, "_self");
          return;
        } else {
          this.$router.push({
            path: item.demoFlag,
            query: {
              id: item.id,
            },
          });
        }
      } else {
        if (item.opennew !== "1") {
          let idflag = item.id;
          if (item.urlMenu == "4") {
            window.open(item.demoFlag, "_self");
          }
          //增加跳转别菜单的判断
          if (item.urlMenu === "3") {
            let array = item.parentIds.split(",");
            idflag = array[array.length - 1];
          }
          this.$router.push({
            path: item.demoFlag,
            query: {
              id: idflag,
            },
          });
        } else {
          this.$store.dispatch("UpdateActive", item);
        }
      }
    },
    toLink(name, sign) {
      let MenuQueryDto = {};
      if (sign) {
        MenuQueryDto = { name: name, sign: sign };
      } else {
        MenuQueryDto = { name: name };
      }
      menuqueryaddressid(MenuQueryDto).then((res) => {
        if (res.data) {
          if (res.data.opennew !== "1") {
            this.$router.push({
              path: res.data.demoFlag,
              query: {
                id: res.data.id,
              },
            });
          } else {
            this.$store.dispatch("UpdateActive", res.data);
          }
        }
      });
    },
    togo(name) {
      if (name == "优速快递") {
        window.open("https://www.uce.cn/", "_blank");
      } else if (name == "汇森速运") {
        window.open("https://www.huisenky.com/", "_blank");
      } else if (name == "汇霖丰通") {
        window.open("https://www.huilin56.com/", "_blank");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  border-top: 1px solid #ccc;
  .main {
    min-height: 250px;
    background-color: #221814;
    padding-bottom: 40px;
    border-bottom: 1px solid #383838;
    .topp {
      padding-top: 40px;
      // background-color: #ccc;
      .maincente {
        display: flex;
      }
      .cente {
        flex: 1;
        .hovers {
          cursor: pointer;
        }
      }
      a {
        color: #fff;
        text-decoration: none;
      }
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        color: #fff;
        li {
          font-size: 13px;
          color: #b1b1b1;
          margin-top: 15px;
          a {
            font-size: 13px;
            color: #b1b1b1;
          }
          a:hover {
            color: #fabe00;
          }
        }
        li:hover {
          cursor: pointer;
          color: #fabe00;
        }
        .email {
          margin-top: 10px;
        }
      }
      .defaul {
        li {
          color: #666 !important;
        }
      }
      img {
        // width: 100%;
        margin-top: 20px;
      }

      .grid {
        font-size: 17px;
      }
      .aboutus {
        // min-width: 200px !important;
        float: left;
        ul {
          // width: 200px;
          span {
            display: inline-block;
            cursor: pointer;
            position: relative;
            top: 30px;
            left: -10px;
            margin-left: 10px;
            width: 36px !important;
            height: 36px !important;
            border-radius: 18px;
            img {
              width: 140px;
              height: 140px;
              position: absolute;
              bottom: 58px;
              left: -50px;
              display: none;
            }
            .ceart {
              display: none;
              width: 0;
              height: 0;
              border-width: 14px 18px 0;
              border-style: solid;
              border-color: #fff transparent transparent;
              position: absolute;
              bottom: 48px;
            }
            .iconfont {
              position: relative;
              left: 7px;
              top: 6px;
              font-size: 22px;
              color: #fff;
            }
          }
          .aleft {
            margin-left: 19px;
          }
          span:hover {
            img {
              display: block;
            }
            .ceart {
              display: block;
            }
          }
          span {
            background-color: #4d4744;
          }
          .tele {
            margin-top: 60px;
          }
        }
      }
      .titles {
        color: #fff;
      }
    }
    .yellow {
      color: #fabe00;
    }
  }
  .page {
    width: 100%;
    height: 56px;
    font-size: 13px;
    background-color: #221814;
    text-align: center;
    border-bottom: 1px solid #383838;
    span {
      cursor: pointer;
      color: #c6c6c6;
      margin: 0 10px;
      line-height: 57px;
      a {
        text-decoration: none;
        line-height: 56px;
        color: #c6c6c6;
      }
    }
  }
  .copy {
    font-size: 13px;
    height: 52px;
    background-color: #221814;
    line-height: 52px;
    color: #c6c6c6;
    text-align: center;
    img {
      margin: -5px 6px;
    }
    a {
      color: #c6c6c6;
    }
    a:hover {
      color: #fabe00;
    }
  }
}
</style>
